<template>
    <div 
        :data-component-name="$options.name"
        :class="(!field.inputClass) ? 'o-grid-12' : field.inputClass"
        v-if="!disabledIDs.includes(field.id)"
    >
        <inputlabel :field="field" :showInstructions="true" />
        <!-- <pre>{{ field }}</pre> -->
        <div class="o-form__item o-input__imagecheckbox__container"
            :class="{'o-radio__group': this.field.inputType === 'inlinecheckbox'}"
        >
            <div
                class="o-input__imagecheckbox__wrap"
                :class="{
                    'o-checkbox__wrap': this.field.inputType !== 'inlinecheckbox',
                    'o-radio__wrap': this.field.inputType === 'inlinecheckbox'
                }"
                v-for="(choice, ci) in choices"
                :key="'cb-'+ci+'-'+field.id"
            >
                <label style="flex-grow:1">
                    <!-- Inline SVG if available in svgContentMap -->
                    <span class="o-input__imagecheckbox__ico">
                        <span class="" v-if="choice.picto && svgContentMap[choice.picto] && choice.picto.substring(choice.picto.lastIndexOf('.') + 1)=='svg'" v-html="svgContentMap[choice.picto]"></span>
                        <span class="" v-else-if="choice.picto && choice.picto.substring(choice.picto.lastIndexOf('.') + 1)!=='svg'"><img :src="choice.picto"></span>
                    </span>
                    <div class="o-input__imagecheckbox__label">
                        <input
                            class="o-input__imagecheckbox"
                            v-model="field.value"
                            :class="{ 
                                'o-checkbox': this.field.inputType !== 'inlinecheckbox',
                                'o-radio': this.field.inputType === 'inlinecheckbox',
                                'readonly': field.inputReadonly === true,
                                'required': requiredField === true
                            }"
                            v-on="readOnlyHandlers"
                            :type="(field.inputChoicesMultiple) ? 'checkbox' : 'radio'"
                            :id="'input-' +ci+'-'+field.id"
                            :name="(field.inputChoices.length>1) ? field.inputName+'[]' : field.inputName"
                            :placeholder="field.inputPlaceholder"
                            :value="(String(choice.value).trim() != '') ? choice.value : choice.text"
                            :required="requiredField"
                        >
                        <label 
                            :class="{
                                'o-checkbox-label': this.field.inputType !== 'inlinecheckbox',
                                'o-radio-label': this.field.inputType === 'inlinecheckbox'
                            }"
                            :for="'input-' + ci + '-' + field.id" 
                        >
                            <span v-html="(String(choice.text).trim() != '') ? choice.text : choice.value"></span>
                        </label>
                        <div class="o-form__validation">
                            <span class="o-form__validation__required" v-if="field.inputChoices.length<2">
                                {{ _t('Ce champ est obligatoire.') }}
                            </span>
                            <span class="o-form__validation__required" v-else v-html="validationMsg"></span>
                            <span class="o-form__validation__error">
                                {{ _t('Ce champ est invalide.') }}
                            </span>
                        </div>
                    </div>
                </label>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';

export default {
    name: 'Input-imagecheckbox',
    props: {
        field: {
            type: Object,
            default() {
                return {}
            },
        },
        disabledIDs: {
            type: Array,
            default() {
                return []
            },
        },
    },
    data() {
        return {
            selected: [],
            requiredField: false,
            svgContentMap: {}, // Store SVG markup by URL
            readOnlyHandlers: {
                keydown: this.handleEvent,
                paste: this.handleEvent,
                focus: this.handleEvent,
                mousedown: this.handleEvent,
            },
            validationMsg: this._t('Veuillez sélectionner au moins une option.'),
        };
    },
    mounted() {
        if (this.field.inputChoicesMultiple && this.field.inputMinSelected && String(this.field.inputMinSelected) != "" && parseInt(this.field.inputMinSelected) > 0) {
            this.field.inputRequired = true;
        }
        this.requiredField = this.field.inputRequired;

        if (this.field.value === null) {
            this.field.value = [];
        }
        if (this.field.value !== null && !Array.isArray(this.field.value)) {
            this.field.value = [this.field.value];
        } else {
            this.selected = this.field.value;
        }

        if (!this.field.value.length && this.field.inputChoices.length) {
            let defaultValue = this.field.inputChoices.find(choice => choice.default);
            if (defaultValue) {
                this.selected = [defaultValue.value];
            }
        }

        // Fetch SVG contents for each choice's `picto` URL if available
        this.field.inputChoices.forEach((choice) => {
            if (choice.picto && !this.svgContentMap[choice.picto]) {
                this.fetchSVGContent(choice.picto);
            }
        });
    },
    watch: {
        selected: function () {
            
            this.field.value = this.selected;
        },

        'field.value': {
            handler(newVal) {


                this.requiredField = false;

                if (this.field.inputRequired === true && this.field.value !== null && this.field.value.length == 0) {
                    this.requiredField = true;
                }

                if (!this.field.inputChoicesMultiple) return;

                if (this.field.inputMinSelected && String(this.field.inputMinSelected) != "") {
                    let min = parseInt(this.field.inputMinSelected);
                    if (min > 0 && this.field.value && this.field.value.length < min) {
                        this.validationMsg = this._t('Veuillez sélectionner au moins ') + (min == 1 ? '1 option.' : min + ' options.');
                        this.requiredField = true;
                    }
                }

                if (this.field.inputMaxSelected && String(this.field.inputMaxSelected) != "") {
                    let max = parseInt(this.field.inputMaxSelected);
                    if (max > 0 && this.field.value && this.field.value.length > max) {
                        this.validationMsg = this._t('Veuillez sélectionner au maximum ') + (max == 1 ? '1 option.' : max + ' options.');
                        this.requiredField = true;
                        this.field.value = this.field.value.slice(1, max + 1); // Trim to max, keep latest selections
                    }
                }
            },
            deep: true,
            immediate: true
        }
    },
    computed: {
        choices() {
            return this.field.inputChoices.map(choice => {
                return {
                    value: (String(choice.value).trim() != '') ? choice.value : choice.text,
                    text: choice.text,
                    picto: choice.picto,
                    default: choice.default,
                };
            });
        }
    },
    methods: {
        toggleValue(value) {
            if (this.field.inputChoicesMultiple) {
                if (this.field.value.includes(value)) {
                    this.field.value = this.field.value.filter(v => v !== value);
                } else {
                    this.field.value.push(value);
                }
            } else {
                if (this.field.value.includes(value)) {
                    this.field.value = this.field.value.filter(v => v !== value);
                } else {
                    this.field.value = [value];
                }
            }
        },
        handleEvent(e) {
            if (this.field.inputReadonly === true && (!e.keyCode || e.keyCode != 9)) e.preventDefault();
        },
        async fetchSVGContent(url) {
            try {
                const response = await axios.get(url, { responseType: 'text' });
                this.svgContentMap[url] = response.data;
            } catch (error) {
                console.error(`Failed to load SVG from ${url}:`, error);
            }
        }
    }
};
</script>
